const FEED_SCROLL_KEY = 'prii-events-feed-scroll';
const SEARCH_SCROLL_KEY = 'prii-events-search-scroll';
const SEARCH_SCROLL_QUERY_KEY = 'prii-events-search-scroll-q';

function getMainEl() {
  if (typeof document === 'undefined') return null;
  return document.querySelector('main');
}

function persistScroll(key, scrollTop, queryExtras) {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(key, String(scrollTop));
  if (queryExtras) {
    sessionStorage.setItem(queryExtras.queryKey, queryExtras.queryValue ?? '');
  }
}

function applyScroll(scrollTop) {
  const main = getMainEl();
  if (!main) return;
  main.scrollTop = scrollTop;
}

/** Re-apply once after layout — main content height can shift on first paint. */
export function restoreMainScrollTop(scrollTop) {
  applyScroll(scrollTop);
  requestAnimationFrame(() => applyScroll(scrollTop));
  window.setTimeout(() => applyScroll(scrollTop), 0);
}

export function saveEventsFeedScroll() {
  const main = getMainEl();
  if (!main) return;
  persistScroll(FEED_SCROLL_KEY, main.scrollTop);
}

export function restoreEventsFeedScroll() {
  if (typeof sessionStorage === 'undefined') return false;
  const saved = sessionStorage.getItem(FEED_SCROLL_KEY);
  if (saved == null) return false;
  restoreMainScrollTop(Number(saved));
  return true;
}

export function saveEventsSearchScroll(query) {
  const main = getMainEl();
  if (!main) return;
  persistScroll(SEARCH_SCROLL_KEY, main.scrollTop, {
    queryKey: SEARCH_SCROLL_QUERY_KEY,
    queryValue: query ?? '',
  });
}

export function restoreEventsSearchScroll(query) {
  if (typeof sessionStorage === 'undefined') return false;
  const saved = sessionStorage.getItem(SEARCH_SCROLL_KEY);
  if (saved == null) return false;
  const savedQuery = sessionStorage.getItem(SEARCH_SCROLL_QUERY_KEY) ?? '';
  if (savedQuery !== (query ?? '')) return false;
  restoreMainScrollTop(Number(saved));
  return true;
}

export function attachMainScrollPersistence(onSave) {
  const main = getMainEl();
  if (!main) return () => {};

  let timer;
  const onScroll = () => {
    clearTimeout(timer);
    timer = window.setTimeout(onSave, 120);
  };

  main.addEventListener('scroll', onScroll, { passive: true });
  return () => {
    clearTimeout(timer);
    main.removeEventListener('scroll', onScroll);
  };
}
